module.exports = __webpack_public_path__ + "img/crew_adv_07.05622549.png";